import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class CreditCardType
 * @property {integer} id
 * @property {Property} property
 * @property {integer} type
 * @property {integer} accept_on_direct_reservations
 * @property {integer} accept_on_booking_engine'
 */
export class CreditCardType extends TranslatableModel {

    static get TYPE_VISA() {

        return 1;
    }

    static get TYPE_MASTERCARD() {

        return 2;
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', 'property', 'property_id', 'type', 'accept_on_direct_reservations', 'accept_on_booking_engine')(CreditCardType);



// WEBPACK FOOTER //
// ./src/pms-api/models/credit-card-type.model.js